import api from '@/api';

/**
 * @class ClientAction
 */
class Assets {
  /**
   * Get a list of client assets
   *
   * @param params
   * @param cancelSource
   * @returns {AxiosPromise<any>}
   */
  static list(params, cancelSource = null) {
    if (cancelSource) {
      params.cancelToken = cancelSource.token;
    }

    return api.get(`/assets/properties`, params);
  }

  /**
   * Get a list of property assets
   *
   * @param propertyId
   * @param params
   * @param cancelSource
   * @returns {AxiosPromise<any>}
   */
  static propertyAssets(propertyId, params, cancelSource = null) {
    if (cancelSource) {
      params.cancelToken = cancelSource.token;
    }

    return api.get(`/properties/${propertyId}/assets`, params);
  }

  /**
   * Get a list of property assets
   *
   * @param propertyId
   * @param assetId
   * @returns {AxiosPromise<any>}
   */
  static getPhotos(propertyId, assetId) {
    return api.get(`/properties/${propertyId}/assets/${assetId}/photos`);
  }

  /**
   * Gets counts for assets key'd by type
   *
   * @param propertyTenure
   * @param includeBreakdown
   * @returns {Promise<AxiosResponse<T>>}
   */
  static getCounts(propertyTenure, includeBreakdown = false) {
    return api.get('/assets/counts', { params: { propertyTenure, includeBreakdown } });
  }
}

export default Assets;
